export default "__VITE_ASSET__5ajN37cT__"